<template>
    <popup :show="true" width="636px" @on-close="onClose">
        <div class="create-folder">
            <div class="create-folder-title">新建文件夹</div>
            <div class="create-form-label">团队文件</div>
            <div class="create-form-input">
                <input type="text" placeholder="文件夹名称" v-model="folder_name" />
            </div>
            <div class="permission-btn-box">
                <div class="permission">
                    权限设置:{{folder_permission | permission}}<Poptip placement="bottom-end" trigger="hover">
                        <template #content>
                            <div class="permission-box">
                                <div class="permission-item" @click="onPermissionSelected('1')">
                                    <Icon v-if="folder_permission == '1'"
                                    type="md-checkmark"
                                    class="selected-icon"
                                    size="16"
                                    />公开可见
                                </div>
                                <div class="permission-item" @click="onPermissionSelected('0')">
                                    <Icon v-if="folder_permission == '0'"
                                    type="md-checkmark"
                                    class="selected-icon"
                                    size="16"
                                    />仅自己可见
                                </div>
                            </div>
                        </template>
                        <Icon type="ios-arrow-down" />
                    </Poptip>
                </div>
                <div class="btn-box">
                    <div class="btn" @click="onClose">取消</div>
                    <div class="btn" @click="onCreateFolder">确定</div>
                </div>
            </div>
        </div>
    </popup>
</template>
<script>
import { teamFolderCreate, teamFolderUpdate } from '@/api/index';
import Popup from '@/components/Popup.vue';
export default{
    name:"CreateFolder",
    components:{
        Popup
    },
    filters:{
        permission(permission){
            switch(Number(permission)){
                case 1: return "公开可见";
                default:return "仅自己可见";
            }
        }
    },
    props:{
        teamId:{
            type:String,
            default:''
        },
        directoryId:{
            type:String,
            default:''
        },
        folderName:{
            type:String,
            default:''
        },
        isRename:{
            type:Boolean,
            default:false
        },
        currPermission:{
            type:[String,Number],
            default:''
        },
        renameFolderId:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            folder_name:'',
            folder_permission:'1'
        }
    },
    mounted(){
        if(this.isRename){
            this.folder_name = this.folderName;
        }
        if([0,1].includes(this.currPermission)){
            this.folder_permission = this.currPermission;
        }
    },
    methods:{
        async onCreateFolder(){
            try{
                const param = {};
                param.team_uuid = this.teamId;
                param.name = this.folder_name;
                param.is_visible = this.folder_permission;
                if(this.isRename){
                    param.directory_uuid = this.renameFolderId;
                }else{
                    param.parent_directory_uuid = this.directoryId;
                }
                console.log('param-create-folder',param);
                let response;
                if(this.isRename){
                    response = await teamFolderUpdate(param);
                }else{
                    response = await teamFolderCreate(param);
                }
                const {code,msg} = response;
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$emit('on-create-folder');
                this.onClose();
            }catch(e){
                console.log('err-create-folder',e);
                this.$layer.msg(e.msg || JSON.stringify(e));
            }
        },
        onPermissionSelected(permission){
            this.folder_permission = permission;
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
    .create-folder{
        width:100%;
        border-radius:15px;
        background:#ffffff;
        padding:30px 50px;
        display:flex;
        flex-direction:column;
        .create-folder-title{
            color:#1a1a1a;
            font-size:24px;
            font-weight:bold;
        }
        .create-form-label{
            margin-top:30px;
            color:#666666;
            font-size:14px;
        }
        .create-form-input{
            width:100%;
            height:52px;
            border-radius:5px;
            border:1px solid #2254f4;
            padding:0 20px;
            margin-top:20px;
            input{
                width:100%;
                height:100%;
                border:none;
                outline:none;
            }
        }
        .permission-btn-box{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:space-between;
            margin-top:50px;
            .permission{
                display:flex;
                align-items:center;
                color:#666666;
                font-size:14px;
                .permission-box{
                    display:flex;
                    flex-direction:column;
                    .permission-item{
                        display:flex;
                        align-items:center;
                        column-gap:9px;
                        height:46px;
                        cursor:pointer;
                        &:hover{
                            background:#f7f7f7;
                        }
                        .selected-icon{
                            color: #f75664;
                        }
                    }
                }
            }
            .btn-box{
                display:flex;
                align-items:center;
                column-gap:9px;
                .btn{
                    width:110px;
                    height:32px;
                    border-radius:6px;
                    background:#ffffff;
                    border:1px solid #dedee0;
                    line-height:32px;
                    text-align:center;
                    cursor:pointer;
                    color:#4d4d4d;
                    font-size:14px;
                    &:last-child{
                        color:#ffffff;
                        background:#ff5967;
                        border:none;
                    }
                }
            }
        }
    }
</style>
